// extracted by mini-css-extract-plugin
module.exports = {"goBack":"AdacHistoryPage_goBack__n6qJf"};